import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import { useAuth } from 'contexts/AuthContext';
import { useShellConfig } from 'contexts/ShellConfigContext';

const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const QaSessionPage = Loadable(lazy(() => import('pages/qa/SessionPage')));
const ForgotPasswordPage = Loadable(lazy(() => import('pages/auth/ForgotPassword')));
const ResetPasswordPage = Loadable(lazy(() => import('pages/auth/ResetPassword')));
const MustChangePasswordPage = Loadable(lazy(() => import('pages/auth/MustChangePassword')));
const PrivacyPolicyPage = Loadable(lazy(() => import('pages/legal/PrivacyPolicy')));
const TermsOfServicePage = Loadable(lazy(() => import('pages/legal/TermsOfService')));

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  const { homePath } = useShellConfig();
  if (loading) return null;
  if (user) {
    const target = user.mustChangePassword ? '/must-change-password' : homePath;
    return <Navigate to={target} replace />;
  }
  return children;
}

const LoginRoutes = {
  path: '/',
  children: [
    { path: '/qa/session', element: <QaSessionPage /> },
    {
      path: '/login',
      element: (
        <GuestOnly>
          <LoginPage />
        </GuestOnly>
      )
    },
    {
      path: '/forgot-password',
      element: (
        <GuestOnly>
          <ForgotPasswordPage />
        </GuestOnly>
      )
    },
    {
      path: '/reset-password',
      element: (
        <GuestOnly>
          <ResetPasswordPage />
        </GuestOnly>
      )
    },
    { path: '/must-change-password', element: <MustChangePasswordPage /> },
    { path: '/privacy', element: <PrivacyPolicyPage /> },
    { path: '/terms', element: <TermsOfServicePage /> }
  ]
};

export default LoginRoutes;
